"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cn = cn;
function cn(...values) {
    const out = [];
    for (const value of values) {
        if (!value)
            continue;
        if (typeof value === 'string' || typeof value === 'number') {
            out.push(String(value));
        }
        else if (Array.isArray(value)) {
            const nested = cn(...value);
            if (nested)
                out.push(nested);
        }
        else {
            for (const [key, enabled] of Object.entries(value)) {
                if (enabled)
                    out.push(key);
            }
        }
    }
    return out.join(' ');
}
//# sourceMappingURL=utils.js.map